'use client';

import React, { useState } from 'react';
import FullSyllabusModal from './FullSyllabusModal';
import styles from './styles/SyllabusSection.module.css';

export default function SyllabusSection({
  teacher,
  lessons,
  user,
  onAddLesson,
  onEditLesson,
  onDeleteLesson,
}) {
  // Show only the first 2 lessons in partial view
  const partialLessons = lessons.slice(0, 2);

  // State to open/close the “See Full Syllabus” modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <section className={styles.courseDetailsSection}>
      <h2>Syllabus</h2>

      <div className={styles.lessonSection}>
      {/* If lessons exist, show up to the first two */}
      {partialLessons.length === 0 ? (
        <p>No lessons yet.</p>
      ) : (
        partialLessons.map((lesson) => (
          <div key={lesson.id} className={styles.lessonItem}>
            <h3 className={styles.lessonTitle}>{lesson.lessonName}</h3>
            <div className={styles.lessonContent}>
              <div className={styles.lessonDesc}>
                <p style={{ whiteSpace: 'pre-wrap' }}>{lesson.description}</p>
                {/* Admin controls (Edit/Delete) */ /* Now Includes Teacher role*/}
                {user?.role === 'ADMIN' || user?.role === 'SUPER_ADMIN' || (user?.role === 'TEACHER' && teacher?.id === user.id) ? (
                  <div className={styles.adminControls}>
                    <button
                      className={styles.editBtn}
                      onClick={() => onEditLesson(lesson.id)}
                    >
                      Edit
                    </button>
                    <button
                      className={styles.deleteBtn}
                      onClick={() => onDeleteLesson(lesson.id)}
                    >
                      Delete
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        ))
      )}
      </div>

      <div className={styles.btnSection}>

      {/* “See Full Syllabus” button => opens modal */}
      {lessons.length > 2 && (
        <button className={styles.seeFullBtn} onClick={handleOpenModal}>
          See Full Syllabus
        </button>
      )}

      {/* If admin, show an "Add Lesson" button */
      /*Note, if there's an error here its probably the teacher part*/}
      {user?.role === 'ADMIN' || user?.role === 'SUPER_ADMIN' || (user?.role === 'TEACHER' && teacher?.id === user.id) ? (
        <button className={`${styles.btn} ${styles.addLessonBtn}`} onClick={onAddLesson}>
          + Add Lesson
        </button>
      ) : null}

      {/* Full Syllabus Modal */}
      <FullSyllabusModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        lessons={lessons}
        user={user}
        teacher={teacher}
        onEditLesson={onEditLesson}
        onDeleteLesson={onDeleteLesson}
      />
      </div>
    </section>
  );
}
